const createPortalRoot = (id) => {
    const drawerRoot = document.createElement('div');
    drawerRoot.setAttribute('id', id);
    const body = document.querySelector('body');
    body.appendChild(drawerRoot);
    return drawerRoot;
};
const removePortalRoot = (id) => {
    const drawerRoot = document.getElementById(id);
    if (!drawerRoot)
        return;
    drawerRoot.remove();
};

export { createPortalRoot, removePortalRoot };
//# sourceMappingURL=portalRoot.js.map
